import React from 'react';

class PlayersCount extends React.Component {
  render() {
    return <div className="game__count">{this.props.label}: {this.props.totalPlayersNum} из {this.props.numberOfPlayers}</div>
  }
}

export default PlayersCount;
